<template>
    <v-layout row justify-center>
        <v-dialog
            v-model="dialog"
            light
            fullscreen
            hide-overlay
            transition="dialog-bottom-transition"
            scrollable
        >
            <v-card tile>
                <v-toolbar
                    card
                    dark
                    class="teal"
                    :class="{'darken-2': !this.$vuetify.dark, 'darken-4': this.$vuetify.dark}"
                >
                    <v-toolbar-title>{{ $t("print") }}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon dark @click="dialog = false">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-toolbar>

                <!-- Печать текущего постава -->
                <v-sheet class="d-flex" v-if="printType == 'pattern'">
                    <v-card xs12 flat>
                        <v-card-text>
                            <v-layout row wrap style="height: 608px;">
                                <v-flex xs12 lg6 class="text-xs-center h-100">
                                    <p class="title-text"> {{ $store.getters.settings.report.title }} </p>
                                    <div class="pattern-container">
                                        <div>
                                            <pattern-vue
                                                :pattern="pattern"
                                                :sizeNominal="sizeNominal"
                                                :falseCore="falseCore"
                                                :ellipseRatio="logInfo.ellipseRatio"
                                                :rotate="logInfo.rotationAngle"
                                                :showDiameter="false"
                                                :showCross="true"
                                                :showCutScheme="showCutScheme"
                                                :logDTop="logInfo.dTop"
                                                :logDBottom="logInfo.dBottom"
                                                :curvatureHeight="logInfo.length * logInfo.curvature * 9.8"
                                                :patternSolidBG="patternSolidBG"
                                                :rotatePattern="rotatePattern"
                                                sideSize="430"
                                                ref="PatternVue"
                                            />
                                        </div>
                                    </div>
                                    <div style="font-size: 14px;" v-if="showPatternInfo && $store.getters.settings.report.displayPatternSizes">
                                        <p> <b>{{ $t("pattern") }} 1:</b> {{ this.cuttingScheme[2] }}</p>
                                        <p> <b>{{ $t("pattern") }} 2:</b> {{ this.cuttingScheme[3] }}</p>
                                    </div>
                                </v-flex>

                                <v-flex xs12 lg6 class="info-current-pattern h-100" v-if="showPatternInfo">
                                    <div class="head-text">{{ patternName}}</div>
                                    <v-card
                                        class="pa-4 ml-8 mt-4 text-xs-left transparent-bg info-table"
                                        flat
                                        tile
                                    >
                                        <div class="head-text">{{ $t("logParameters")}}</div>
                                        <table>
                                            <tbody>
                                                <tr>
                                                    <td>{{ $t("speciesAlt") }}:</td>
                                                    <td><b>{{ logInfo.species !== null ? $t(logInfo.species) : "" }}</b></td>
                                                    <td>{{ $t("output") }}:</td>
                                                    <td><b>{{ `${output.toFixed(2)} (${outputRaw})` }}%</b></td>
                                                </tr>
                                                <tr>
                                                    <template v-if="$store.getters.settings.report.displayPrices">
                                                        <td>{{ $t("price") }}:</td>
                                                        <td><b>{{ totalPrice }}</b></td>
                                                    </template>
                                                    <td>{{ $t("expenditure") }}:</td>
                                                    <td><b>{{ (1 / output * 100).toFixed(2) }}</b></td>
                                                </tr>
                                                <tr>
                                                    <td>{{ $t("volume") }}:</td>
                                                    <td><b>{{ $num.dropZeros(logInfo.volume) }} {{ $t("m")}}<sup>3</sup></b></td>
                                                    <td>{{ $t("length") }}:</td>
                                                    <td><b>{{ logInfo.length !== undefined && logInfo.length.toFixed(2) }} {{ $t("m")}}</b></td>
                                                </tr>
                                                <tr>
                                                    <td>{{ $t("top") }}:</td>
                                                    <td><b>{{ logInfo.dTop }} {{ $t("mm")}}</b></td>
                                                    <td>{{ $t("bottom") }}:</td>
                                                    <td><b>{{ logInfo.dBottom }} {{ $t("mm")}}</b></td>
                                                </tr>
                                                <tr>
                                                    <td>{{ $t("curvature") }}:</td>
                                                    <td><b>{{ logInfo.curvature !== undefined && logInfo.curvature.toFixed(2) }}%</b></td>
                                                    <td>{{ $t("ellipseRatio") }}:</td>
                                                    <td><b>{{ logInfo.ellipseRatio !== undefined && logInfo.ellipseRatio.toFixed(2) }}%</b></td>
                                                </tr>
                                                <tr v-if="calcTimestamp">
                                                    <td>{{ $t("calculated") }}:</td>
                                                    <td colspan="3"><b>{{ calcTimestamp }}</b></td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </v-card>
                                    <v-card-text class="info-table">
                                        <div class="head-text">{{ $t("calculatedBoards") }}</div>
                                        <v-data-table
                                            :headers="tableHeader"
                                            :items="tableData"
                                            :rows-per-page-items="[100]"
                                            hide-actions
                                            class="dense-table"
                                        >
                                            <template v-slot:items="props">
                                                <td>{{ props.item.size }}</td>
                                                <td>{{ props.item.length }}</td>
                                                <td>{{ props.item.qty }}</td>
                                                <td>{{ props.item.volume }}</td>
                                                <td>{{ props.item.percent }}</td>
                                                <td v-if="$store.getters.settings.report.displayPrices" class="text-xs-right">{{ props.item.price }}</td>
                                            </template>
                                        </v-data-table>
                                    </v-card-text>
                                </v-flex>

                                <v-sheet
                                    class="d-flex ml-4 mt-5"
                                    xs12 lg6
                                    v-else
                                >
                                    <div class="mt-5">
                                        <p class="head-text">{{ $t("pattern") }}</p>
                                        <p><b>{{ $t("name") }}:</b> {{ this.selectedPattern.name }}</p>
                                        <p><b>{{ $t("speciesAlt") }}:</b> {{ this.selectedPattern.speciesTranslated }}</p>
                                        <p><b>{{ $t("diameterU") }}:</b> {{ this.selectedPattern.Du }}</p>
                                        <p><b>{{ $t("pattern") }} 1:</b> {{ this.cuttingScheme[2] }}</p>
                                        <p><b>{{ $t("pattern") }} 2:</b> {{ this.cuttingScheme[3] }}</p>
                                        <p><b>{{ $t("createModifyDate") }}:</b> {{ this.selectedPattern.updatedAt ? this.selectedPattern.updatedAt : "" }}</p>
                                    </div>
                                </v-sheet>
                            </v-layout>
                        </v-card-text>
                    </v-card>
                </v-sheet>


                <!-- Печать для партии бревен -->
                <v-container
                    v-if="printType == 'batch'"
                    style=""
                    class="ma-0"
                >
                    <v-layout row wrap>
                        <v-flex xs5 class="mb-1"></v-flex>
                        <v-flex xs7 class="mb-1" style="flex-basis: 100%;">
                            {{ $t("date") }}:       _____________________
                            {{ $t("customer") }}:   _____________________
                            №:                      _____________________
                        </v-flex>

                        <v-flex xs4>
                            <pattern-vue
                                :pattern="pattern"
                                :sizeNominal="sizeNominal"
                                :falseCore="falseCore"
                                :ellipseRatio="logInfo.ellipseRatio"
                                :rotate="logInfo.rotationAngle"
                                :showDiameter="false"
                                :showCross="true"
                                :logDTop="logInfo.dTop"
                                :logDBottom="logInfo.dBottom"
                                :curvatureHeight="logInfo.length * logInfo.curvature * 9.8"
                                :patternSolidBG="patternSolidBG"
                                :rotatePattern="rotatePattern"
                                sideSize="280"
                                ref="PatternVue"
                            />
                        </v-flex>
                        <v-flex xs3>
                            <table class="info-batch-log body-1">
                                <tbody>
                                    <tr>
                                        <td>{{ $t("speciesAlt") }}:</td>
                                        <td><b>{{ logInfo.species !== null ? $t(logInfo.species) : "" }}</b></td>
                                        <td>{{ $t("output") }}:</td>
                                        <td><b>{{ `${output.toFixed(2)} (${outputRaw})` }}%</b></td>
                                    </tr>
                                    <tr>
                                        <td>{{ $t("price") }}:</td>
                                        <td><b>{{ totalPrice }}</b></td>
                                        <td>{{ $t("expenditure") }}:</td>
                                        <td><b>{{ (1 / output * 100).toFixed(2) }}</b></td>
                                    </tr>
                                    <tr>
                                        <td>{{ $t("volume") }}:</td>
                                        <td><b>{{ $num.dropZeros(logInfo.volume) }} {{ $t("m")}}<sup>3</sup></b></td>
                                        <td>{{ $t("length") }}:</td>
                                        <td><b>{{ logInfo.length !== undefined && logInfo.length.toFixed(2) }} {{ $t("m")}}</b></td>
                                    </tr>
                                    <tr>
                                        <td>{{ $t("top") }}:</td>
                                        <td><b>{{ logInfo.dTop }} {{ $t("mm")}}</b></td>
                                        <td>{{ $t("bottom") }}:</td>
                                        <td><b>{{ logInfo.dBottom }} {{ $t("mm")}}</b></td>
                                    </tr>
                                    <tr>
                                        <td>{{ $t("curvature") }}:</td>
                                        <td><b>{{ logInfo.curvature !== undefined && logInfo.curvature.toFixed(2) }}%</b></td>
                                        <td>{{ "Эллипс" }}:</td>
                                        <td><b>{{ logInfo.ellipseRatio !== undefined && logInfo.ellipseRatio.toFixed(2) }}%</b></td>
                                    </tr>
                                    <tr>
                                        <td colspan="2">{{ $t("logsAmount") }}</td>
                                        <td><b>{{ logsAmount }} {{ $t("pc")}}</b></td>
                                    </tr>
                                </tbody>
                            </table>
                        </v-flex>
                        <v-flex xs5>
                            <v-card-text>
                                <template >
                                    <v-data-table
                                        :headers="tableHeader"
                                        :items="tableData"
                                        :rows-per-page-items="[100]"
                                        hide-actions
                                        class="dense-table"
                                        :class="{ 'font-size-decreased-1': boardsData.length == 6, 'font-size-decreased-2': boardsData.length > 6 }"
                                        style="border: 1px solid black;"
                                    >
                                        <template v-slot:items="props">
                                            <td>{{ props.item.nomSize }}</td>
                                            <td>{{ props.item.length }}</td>
                                            <td>{{ props.item.qty }}</td>
                                            <td>{{ props.item.volume }}</td>
                                            <td class="text-xs-right">{{ props.item.price }}</td>
                                        </template>
                                    </v-data-table>
                                </template>
                            </v-card-text>
                        </v-flex>
                        <div class="ma-1"></div>
                        <v-flex xs12 style="flex-basis: 100%;">
                            <table
                                class="simple-data-table"
                                :class="{ 'font-size-decreased-1': boardsData.length == 6, 'font-size-decreased-2': boardsData.length > 6 }"
                            >
                                <thead>
                                    <tr>
                                        <th style="width: 180px;"> {{ $t("dimension") }}</th>
                                        <th style="width: 180px;"> {{ $t("sawSize") }}</th>
                                        <th style="width: 100px;">{{ $t("volume") }}, {{ $t("m")}}<sup>3</sup></th>
                                        <th style="width: 100px;">{{ $t("output") }}</th>
                                        <th style="width: 80px;">{{ $t("price") }}</th>
                                        <th>{{ $t("sorting") }}</th>
                                        <th>{{ $t("humidity") }}</th>
                                        <th>{{ $t("labeling") }}</th>
                                        <th>{{ $t("amount") }}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <template>
                                        <tr
                                            v-for="(item, index) in boardsData"
                                            :key="index"
                                        >
                                            <td>{{item.size}}</td>
                                            <td>{{item.sawSize}}</td>
                                            <td>{{item.size ? item.volume : ""}}</td>
                                            <td>{{item.size ? item.percent : ""}}</td>
                                            <td>{{item.size ? item.price : ""}}</td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                        </tr>
                                    </template>
                                </tbody>
                            </table>
                            <div class="ma-1"></div>
                            <table
                                v-if="printRawMaterial == 1 || printSawWaste == 1"
                                class="simple-data-table"
                                :class="{ 'font-size-decreased-1': boardsData.length == 6, 'font-size-decreased-2': boardsData.length > 6 }"
                                style="max-width: 600px;"
                            >
                                <thead>
                                    <tr>
                                        <th style="width: 180px;"></th>
                                        <th style="width: 100px;">{{ $t("volume") }}, {{ $t("m")}}<sup>3</sup></th>
                                        <th style="width: 100px;">{{ $t("output") }}</th>
                                        <th style="width: 80px;">{{ $t("price") }}</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <template>
                                        <tr
                                            v-for="(item, index) in materialData"
                                            :key="index"
                                        >
                                            <td>{{item.name}}</td>
                                            <td>{{item.volume}}</td>
                                            <td>{{item.percent}}</td>
                                            <td>{{item.price}}</td>
                                            <td></td>
                                        </tr>
                                    </template>
                                </tbody>
                            </table>
                        </v-flex>
                    </v-layout>
                </v-container>

                <div
                    class="footer"
                >
                    <pre>{{ $t("appName") }}   &#xa9; &laquo;{{ $t("avtomatikaVektor") }}&raquo;    https://a-vektor.ru</pre>
                    <span></span>
                </div>
            </v-card>
        </v-dialog>
    </v-layout>
</template>

<script>
import PatternVue from "@/components/patterns/PatternVue";

export default {
    name: "PatternPrintDialog",

    components: {
        PatternVue,
    },

    data() {
        return {
            dialog: false,
            boardsData: [],
            boardsVolume: 0,
            cuttingScheme: ["", "", "", ""],
            pattern: {},
            sizeNominal: "1",
            falseCore: 0,
            output: 0,
            outputRaw: 0,
            logInfo: {},
            logsAmount: 1,
            materialData: [],
            totalPrice: 0,
            calcTimestamp: null,
            tableHeader:   [],
            tableData:     [],
            selectedPattern:    {},
            patternName:        "",
            rotatePattern:      false,
            patternSolidBG:     false,
            showAxes:           true,
            showCutScheme:      false,
            printRawMaterial:   true,
            printSawWaste:      true,
            printType:          "pattern"
        }
    },

    watch: {
        dialog: function(val) {
            //this.$debug.log(this.logInfo);
            if (val == true) {
                if (this.printType == "batch") {
                    this.tableHeader.splice(4,1);
                    this.tableData.splice(this.tableData.length-2,1);
                    this.tableData.splice(this.tableData.length-7,1);

                    this.createTableData();
                } else {
                    if (!this.$store.getters.settings.report.displayPrices) {
                        this.tableHeader.splice(5,1);
                    }
                    this.tableData.splice(this.tableData.length-2,1);
                }

                this.print();
            }
        },


    },

    computed: {
        showPatternInfo () {
            return (this.logInfo !== false);
        }
    },

    mounted () {
        let user = this.$store.getters.user;

        this.patternSolidBG = user.settings == undefined ? false : user.settings.patternSolidBG;
        this.rotatePattern  = user.settings == undefined ? false : user.settings.rotatePattern;
        this.showAxes       = user.settings == undefined ? true  : user.settings.showAxes;

    },

    methods: {

        /**
         * Удаляет незначащие нули
         *
         * @param {number} val Исходное число
         *
         * @returns {number}
         */
        /*
        dropZeros (val) {
            if (isNaN(val)) {
                return "";
            }

            let result = parseFloat(val);

            result = result.toFixed(3).substring(result.toFixed(3).length, result.toFixed(3).length - 1) == "0"
                ? parseFloat(result.toFixed(2))
                : parseFloat(result.toFixed(3));

            if (result == parseInt(val)) {
                result += ".0";
            }

            return result;
        },
        */

        createTableData () {
            let component  = this;
            let dublicate = false;

            this.tableData.forEach((item) => {
                if (item.size) {
                    component.boardsVolume += parseFloat(item.volume);

                    component.boardsData.forEach((subItem) => {
                        if (item.size == subItem.size) {
                            subItem.volume = (parseFloat(item.volume) + parseFloat(subItem.volume)).toFixed(5);
                            subItem.price = (parseFloat(item.price) + parseFloat(subItem.price)).toFixed(2);
                            dublicate = true;
                        }
                    });

                    if (!dublicate) {
                        component.boardsData.push({
                            size: item.nomSize,
                            sawSize: item.sawSize,
                            volume: item.vol,
                            percent: item.percent,
                            price: item.price
                        });
                    }

                    dublicate = false;
                }

                if (item.qty == this.$t("sawdust") && this.printSawWaste)  {
                    component.materialData.push ({
                        name: this.$t("sawdust"),
                        volume: item.volume,
                        percent: item.percent,
                        price: item.price
                    });
                }

                if (item.qty == this.$t("woodChips") && this.printSawWaste)  {
                    component.materialData.push ({
                        name: this.$t("woodChips"),
                        volume: item.volume,
                        percent: item.percent,
                        price: item.price
                    });
                }

                if (item.qty == this.$t("drying") && this.printSawWaste)  {
                    component.materialData.push ({
                        name: this.$t("drying"),
                        volume: item.volume,
                        percent: item.percent,
                        price: ""
                    });
                }

                if (item.qty == this.$t("rawMaterials") && this.printRawMaterial)  {
                    component.materialData.push ({
                        name: this.$t("rawMaterials"),
                        volume: item.volume,
                        percent: "",
                        price: parseFloat(item.price) * -1
                    });
                }
            });

            while (this.boardsData.length < 6) {
                this.boardsData.push({
                    size: "",
                    sawSize: "",
                    volume: "",
                    percent: "",
                    price: ""
                });
            }

        },

        /**
         * Вызывает диалог печати
         */
        print () {
            setTimeout(() => {
                window.print();
                this.boardsData = [];
                this.materialData = [];
                this.boardsVolume = 0;
                this.tableHeader = [];
                this.tableData = [];
                this.dialog = false;
            }, 800);
        },

    }
};
</script>

<style lang="sass" scoped>
    .container.md-up
        .v-scrollable
            overflow-y: auto
            max-height: calc(100vh - 163px)

    .flex-card
        display: flex
        flex-direction: column

        .v-toolbar
            flex: 0

    .v-card__text
        padding: 6px

    .pattern-container
        box-sizing: border-box
        border: 0 !important
        display: inline-block

        &>div
            margin-left: 10px
            margin-top: -15px

    .board *
        border-style: solid
        border-color: black !important

    .briefInfo
        border-width: 1px
        border-color: black !important
        border-style: solid
        text-align: left !important
        height: 200px
        padding: 16px

    .info-table
        border-width: 1px
        border-color: black
        border-style: solid
        margin: 0px !important
        padding-top: 6px !important
        padding-bottom: 6px !important
        td
            padding: 0px
            padding-right: 15px

    .info-current-pattern
        background-color: #fff !important
        margin-left: 25px
        max-width: 450px
        //max-width: 45vw

    .head-text
        text-align: center !important
        font-size: 16px
        padding: 0px
        padding-bottom: 4px
        margin: 0px !important
        font-weight: bold

    .title-text
        text-align: left !important
        font-size: 18px
        padding-bottom: 24px
        margin: 0px !important
        font-weight: bold

    .footer
        text-align: center !important
        position: absolute
        left: 25px
        bottom: 5px

    .flex
        flex-basis: 50%
        align-self: center

    .simple-data-table
        height: 100%
        width: 100%
        text-align: center
        border-spacing: 0
        border: 1px solid black
        border-right: 0
        border-top: 0
        th
            height: 25px
            border: 1px solid black
            border-bottom: 0
            border-left: 0
        td
            height: 25px
            border: 1px solid black
            border-bottom: 0
            border-left: 0

    .transparent-bg
        background: transparent

    .font-size-decreased-1
        td
            height: 20px

    .font-size-decreased-2
        td
            font-size: 12px
            height: 15px
</style>
